// anything that must run first before everything else
import "./src/styles";
import 'react-native-reanimated';
import 'react-native-get-random-values';
import { enableFreeze } from 'react-native-screens';

// for some reason web requires this or it bombs on local storage calls. TODO FIX
import Cognito from './src/utils/cognito/storage';
Cognito.getItem('FAKE');

enableFreeze(true);

import "expo-router/entry"; // normal app start invokes src/app/_layout.tsx